import React from 'react';
import { connect } from 'react-redux';
import BlogCollection from './index';
import addBlogPost from '../../../modules/blog/addBlogPost';
function BlogCollectionContainer({ addBlogPost }) {
  return (
    <BlogCollection addBlogPost={addBlogPost} />
  )
};

const mapActionToProps = {
  addBlogPost,
}

export default connect(undefined, mapActionToProps)(BlogCollectionContainer);




// WEBPACK FOOTER //
// ./src/pages/Admin/BlogCollection/container.js